import ApiService from './api';

/**
 * Goal Service
 * Handles all goal-related API requests
 */
const GoalService = {
  /**
   * Get all goals for the current user
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getAllGoals: async (token) => {
    const response = await ApiService.get('/api/goals', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get a single goal by ID
   * @param {string} goalId - Goal ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getGoalById: async (goalId, token) => {
    const response = await ApiService.get(`/api/goals/${goalId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Create a new goal
   * @param {Object} goalData - Goal data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  createGoal: async (goalData, token) => {
    const response = await ApiService.post('/api/goals', goalData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Update a goal
   * @param {string} goalId - Goal ID
   * @param {Object} goalData - Updated goal data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  updateGoal: async (goalId, goalData, token) => {
    const response = await ApiService.put(`/api/goals/${goalId}`, goalData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Delete a goal
   * @param {string} goalId - Goal ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  deleteGoal: async (goalId, token) => {
    const response = await ApiService.delete(`/api/goals/${goalId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Update goal progress
   * @param {string} goalId - Goal ID
   * @param {Object} progressData - Progress data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  updateProgress: async (goalId, progressData, token) => {
    const response = await ApiService.post(`/api/goals/${goalId}/progress`, progressData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  }
};

export default GoalService;
